// extracted by mini-css-extract-plugin
module.exports = {"exit":"Exit_exit__DJ_aJ","exit-icon":"Exit_exit-icon__g4geK"};